var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4AxTandemSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3095.24 803.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb040;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-176,.cls-177,.cls-178,.cls-179,.cls-180,.cls-181,.cls-182,.cls-183,.cls-184,.cls-185,.cls-186,.cls-187,.cls-188,.cls-189,.cls-190,.cls-191,.cls-192,.cls-193{stroke-width:0px;}.cls-2,.cls-190{fill:#414042;}.cls-3,.cls-6,.cls-7,.cls-70,.cls-194,.cls-173,.cls-174,.cls-176,.cls-186,.cls-187,.cls-190,.cls-192{mix-blend-mode:multiply;}.cls-3,.cls-164{fill:#f1f2f2;}.cls-4{fill:url(#New_Gradient_Swatch_4);}.cls-5{fill:url(#New_Gradient_Swatch_3);}.cls-6{fill:url(#linear-gradient-67);}.cls-7{fill:url(#linear-gradient-66);}.cls-8{fill:url(#New_Gradient_Swatch_3-3);}.cls-9{fill:url(#New_Gradient_Swatch_3-4);}.cls-10{fill:url(#New_Gradient_Swatch_3-9);}.cls-11{fill:url(#New_Gradient_Swatch_3-8);}.cls-12{fill:url(#New_Gradient_Swatch_3-7);}.cls-13{fill:url(#New_Gradient_Swatch_3-6);}.cls-14{fill:url(#New_Gradient_Swatch_3-2);}.cls-15{fill:url(#New_Gradient_Swatch_3-5);}.cls-16{fill:url(#New_Gradient_Swatch_4-3);}.cls-17{fill:url(#New_Gradient_Swatch_4-2);}.cls-18{fill:url(#New_Gradient_Swatch_4-4);}.cls-19{fill:#f7941d;}.cls-20{fill:url(#linear-gradient-120);}.cls-21{fill:url(#linear-gradient-125);}.cls-22{fill:url(#linear-gradient-124);}.cls-23{fill:url(#linear-gradient-126);}.cls-24{fill:url(#linear-gradient-138);}.cls-25{fill:url(#linear-gradient-139);}.cls-26{fill:url(#linear-gradient-134);}.cls-27{fill:url(#linear-gradient-131);}.cls-28{fill:url(#linear-gradient-136);}.cls-29{fill:url(#linear-gradient-132);}.cls-30{fill:url(#linear-gradient-135);}.cls-31{fill:url(#linear-gradient-130);}.cls-32{fill:url(#linear-gradient-133);}.cls-33{fill:url(#linear-gradient-137);}.cls-34{fill:url(#linear-gradient-100);}.cls-35{fill:url(#linear-gradient-101);}.cls-36{fill:url(#linear-gradient-123);}.cls-37{fill:url(#linear-gradient-121);}.cls-38{fill:url(#linear-gradient-122);}.cls-39{fill:url(#linear-gradient-109);}.cls-40{fill:url(#linear-gradient-108);}.cls-41{fill:url(#linear-gradient-106);}.cls-42{fill:url(#linear-gradient-102);}.cls-43{fill:url(#linear-gradient-104);}.cls-44{fill:url(#linear-gradient-103);}.cls-45{fill:url(#linear-gradient-105);}.cls-46{fill:url(#linear-gradient-117);}.cls-47{fill:url(#linear-gradient-118);}.cls-48{fill:url(#linear-gradient-111);}.cls-49{fill:url(#linear-gradient-112);}.cls-50{fill:url(#linear-gradient-127);}.cls-51{fill:url(#linear-gradient-128);}.cls-52{fill:url(#linear-gradient-110);}.cls-53{fill:url(#linear-gradient-113);}.cls-54{fill:url(#linear-gradient-114);}.cls-55{fill:url(#linear-gradient-115);}.cls-56{fill:url(#linear-gradient-116);}.cls-57{fill:url(#linear-gradient-119);}.cls-58{fill:url(#linear-gradient-144);}.cls-59{fill:url(#linear-gradient-145);}.cls-60{fill:url(#linear-gradient-149);}.cls-61{fill:url(#linear-gradient-148);}.cls-62{fill:url(#linear-gradient-146);}.cls-63{fill:url(#linear-gradient-143);}.cls-64{fill:url(#linear-gradient-140);}.cls-65{fill:url(#linear-gradient-141);}.cls-66{fill:url(#linear-gradient-147);}.cls-67{fill:url(#linear-gradient-142);}.cls-68{fill:url(#linear-gradient-151);}.cls-69{fill:url(#linear-gradient-150);}.cls-195{mask:url(#mask);}.cls-70{fill:#fff;}.cls-71,.cls-173{fill:#ed1c24;}.cls-72{fill:url(#linear-gradient);}.cls-196{filter:url(#luminosity-noclip);}.cls-73{fill:#ef4136;}.cls-74{fill:#6d6e71;}.cls-75{fill:#f15a29;}.cls-76{fill:url(#linear-gradient-38);}.cls-77{fill:url(#linear-gradient-33);}.cls-78{fill:url(#linear-gradient-29);}.cls-79{fill:url(#linear-gradient-32);}.cls-80{fill:url(#linear-gradient-30);}.cls-81{fill:url(#linear-gradient-31);}.cls-82{fill:url(#linear-gradient-36);}.cls-83{fill:url(#linear-gradient-39);}.cls-84{fill:url(#linear-gradient-34);}.cls-85{fill:url(#linear-gradient-37);}.cls-86{fill:url(#linear-gradient-35);}.cls-87{fill:url(#linear-gradient-28);}.cls-88{fill:url(#linear-gradient-25);}.cls-89{fill:url(#linear-gradient-11);}.cls-90{fill:url(#linear-gradient-12);}.cls-91{fill:url(#linear-gradient-13);}.cls-92{fill:url(#linear-gradient-10);}.cls-93{fill:url(#linear-gradient-17);}.cls-94{fill:url(#linear-gradient-16);}.cls-95{fill:url(#linear-gradient-19);}.cls-96{fill:url(#linear-gradient-15);}.cls-97{fill:url(#linear-gradient-23);}.cls-98{fill:url(#linear-gradient-21);}.cls-99{fill:url(#linear-gradient-18);}.cls-100{fill:url(#linear-gradient-14);}.cls-101{fill:url(#linear-gradient-22);}.cls-102{fill:url(#linear-gradient-20);}.cls-103{fill:url(#linear-gradient-27);}.cls-104{fill:url(#linear-gradient-24);}.cls-105{fill:url(#linear-gradient-26);}.cls-106{fill:url(#linear-gradient-45);}.cls-107{fill:url(#linear-gradient-46);}.cls-108{fill:url(#linear-gradient-44);}.cls-109{fill:url(#linear-gradient-48);}.cls-110{fill:url(#linear-gradient-49);}.cls-111{fill:url(#linear-gradient-47);}.cls-112{fill:url(#linear-gradient-42);}.cls-113{fill:url(#linear-gradient-43);}.cls-114{fill:url(#linear-gradient-40);}.cls-115{fill:url(#linear-gradient-41);}.cls-116{fill:url(#linear-gradient-59);}.cls-117{fill:url(#linear-gradient-57);}.cls-118{fill:url(#linear-gradient-58);}.cls-119{fill:url(#linear-gradient-55);}.cls-120{fill:url(#linear-gradient-56);}.cls-121{fill:url(#linear-gradient-53);}.cls-122{fill:url(#linear-gradient-51);}.cls-123{fill:url(#linear-gradient-52);}.cls-124{fill:url(#linear-gradient-50);}.cls-125{fill:url(#linear-gradient-54);}.cls-126{fill:url(#linear-gradient-60);}.cls-127{fill:url(#linear-gradient-61);}.cls-128{fill:url(#linear-gradient-62);}.cls-129{fill:url(#linear-gradient-65);}.cls-130{fill:url(#linear-gradient-79);}.cls-131{fill:url(#linear-gradient-78);}.cls-132{fill:url(#linear-gradient-77);}.cls-133{fill:url(#linear-gradient-75);}.cls-134{fill:url(#linear-gradient-76);}.cls-135{fill:url(#linear-gradient-74);}.cls-136{fill:url(#linear-gradient-68);}.cls-137{fill:url(#linear-gradient-63);}.cls-138{fill:url(#linear-gradient-69);}.cls-139{fill:url(#linear-gradient-64);}.cls-140{fill:url(#linear-gradient-71);}.cls-141{fill:url(#linear-gradient-72);}.cls-142{fill:url(#linear-gradient-70);}.cls-143{fill:url(#linear-gradient-73);}.cls-144{fill:url(#linear-gradient-84);}.cls-145{fill:url(#linear-gradient-85);}.cls-146{fill:url(#linear-gradient-82);}.cls-147{fill:url(#linear-gradient-83);}.cls-148{fill:url(#linear-gradient-89);}.cls-149{fill:url(#linear-gradient-88);}.cls-150{fill:url(#linear-gradient-86);}.cls-151{fill:url(#linear-gradient-87);}.cls-152{fill:url(#linear-gradient-80);}.cls-153{fill:url(#linear-gradient-81);}.cls-154{fill:url(#linear-gradient-98);}.cls-155{fill:url(#linear-gradient-91);}.cls-156{fill:url(#linear-gradient-92);}.cls-157{fill:url(#linear-gradient-93);}.cls-158{fill:url(#linear-gradient-90);}.cls-159{fill:url(#linear-gradient-96);}.cls-160{fill:url(#linear-gradient-97);}.cls-161{fill:url(#linear-gradient-94);}.cls-162{fill:url(#linear-gradient-95);}.cls-163{fill:url(#linear-gradient-99);}.cls-165{fill:#58595b;}.cls-166,.cls-174{fill:#bcbec0;}.cls-167{fill:#808285;}.cls-168{fill:url(#New_Gradient_Swatch_3-11);}.cls-169{fill:url(#New_Gradient_Swatch_3-10);}.cls-170,.cls-177{fill:#000;}.cls-171,.cls-176{fill:#a7a9ac;}.cls-172{fill:url(#New_Gradient_Swatch_11_cop);}.cls-175{fill:#be1e2d;}.cls-177{opacity:.5;}.cls-178{fill:url(#linear-gradient-4);}.cls-179{fill:url(#linear-gradient-2);}.cls-180{fill:url(#linear-gradient-3);}.cls-181{fill:url(#linear-gradient-8);}.cls-182{fill:url(#linear-gradient-9);}.cls-183{fill:url(#linear-gradient-7);}.cls-184{fill:url(#linear-gradient-5);}.cls-185{fill:url(#linear-gradient-6);}.cls-186{fill:url(#linear-gradient-129);}.cls-187{fill:url(#linear-gradient-107);}.cls-188,.cls-192{fill:#939598;}.cls-197{isolation:isolate;}.cls-189{fill:#e6e7e8;}.cls-191{fill:#d1d3d4;}.cls-193{fill:#231f20;}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 0,
    y: 716.2,
    width: 3095.24,
    height: 87.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 716.2,
    width: 3095.24,
    height: 87.31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-196"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3096,
    height: 89,
    transform: "translate(-.21 715.22)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -14023.59,
    y1: 449.26,
    x2: -14023.59,
    y2: 352.94,
    gradientTransform: "translate(-13498.57) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#b7b8ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -13986.17,
    y1: 490.56,
    x2: -13986.17,
    y2: 311.88,
    gradientTransform: "translate(-13498.57) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#262224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#525254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#403f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#252122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -13964.69,
    y1: 308.9,
    x2: -13964.69,
    y2: 493.36,
    gradientTransform: "translate(-13498.57) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2b2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3b393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3a393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2a2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 308.89,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    y1: 308.89,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 308.89,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    y1: 308.89,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(14430.81 618.91) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    y1: 308.89,
    y2: 493.35,
    gradientTransform: "translate(14430.81 624.06) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(14430.81 630.42) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(14430.81 638.08) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(14430.81 647.07) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(14430.81 657.16) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(14430.81 668.33) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(14430.81 680.43) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(14430.81 693.77) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(14430.81 707.63) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(14430.81 722.49) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(14430.81 737.8) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    y1: 308.9,
    y2: 493.36,
    gradientTransform: "translate(14430.81 753.83) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(14430.81 770.06) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(14430.81 786.51) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -13964.69,
    y1: 308.9,
    x2: -13964.69,
    y2: 493.36,
    gradientTransform: "translate(14430.81 802.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -14007.66,
    x2: -14007.66,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -14007.66,
    y1: 308.9,
    x2: -14007.66,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -14007.66,
    y1: 308.9,
    x2: -14007.66,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -14007.66,
    y1: 308.9,
    x2: -14007.66,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -14007.66,
    y1: 308.9,
    x2: -14007.66,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -14007.66,
    y1: 308.9,
    x2: -14007.66,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.36,
    gradientTransform: "translate(14516.74 618.91) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.35,
    gradientTransform: "translate(14516.74 624.06) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.37,
    gradientTransform: "translate(14516.74 630.42) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.37,
    gradientTransform: "translate(14516.74 638.08) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.36,
    gradientTransform: "translate(14516.74 647.07) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.37,
    gradientTransform: "translate(14516.74 657.16) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.37,
    gradientTransform: "translate(14516.74 668.33) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.37,
    gradientTransform: "translate(14516.74 680.43) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.37,
    gradientTransform: "translate(14516.74 693.77) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.36,
    gradientTransform: "translate(14516.74 707.63) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.37,
    gradientTransform: "translate(14516.74 722.49) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.37,
    gradientTransform: "translate(14516.74 737.8) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -14007.66,
    y1: 308.9,
    x2: -14007.66,
    y2: 493.36,
    gradientTransform: "translate(14516.74 753.83) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.36,
    gradientTransform: "translate(14516.74 770.06) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -14007.66,
    y1: 308.89,
    x2: -14007.66,
    y2: 493.36,
    gradientTransform: "translate(14516.74 786.51) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -14007.66,
    y1: 308.9,
    x2: -14007.66,
    y2: 493.36,
    gradientTransform: "translate(14516.74 802.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -13986.17,
    y1: 310.39,
    x2: -13986.17,
    y2: 493.86,
    gradientTransform: "translate(14473.77 802.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 159.36,
    y1: 400.05,
    x2: 159.36,
    y2: 259.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 306.57,
    y1: 400.05,
    x2: 306.57,
    y2: 259.24,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 398.49,
    y1: 491.35,
    x2: 398.49,
    y2: 409.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#1f0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4a0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#640000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -9581.58,
    y1: 135.17,
    x2: -9581.58,
    y2: 53.6,
    gradientTransform: "translate(-9166.79 570.47) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#020000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0c0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1b0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#320000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4e0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -9721.77,
    y1: 188.13,
    x2: -9721.77,
    y2: 255.97,
    gradientTransform: "translate(-8359.96 -3729.66) rotate(-153.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -9721.77,
    y1: 248.18,
    x2: -9721.77,
    y2: 195.11,
    gradientTransform: "translate(-6616.18 -6256.2) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#938167"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -9721.77,
    y1: 200.86,
    x2: -9721.77,
    y2: 242.84,
    gradientTransform: "translate(-9306.98 683.01) rotate(-180)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -9721.77,
    y1: 238.02,
    x2: -9721.77,
    y2: 205.17,
    gradientTransform: "translate(-9306.98 683.01) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d8f8a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 398.07,
    y1: 306.04,
    x2: 381.68,
    y2: 306.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 264.18,
    y1: 717.26,
    x2: 264.18,
    y2: 530.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    x1: 264.18,
    y1: 547.37,
    x2: 264.18,
    y2: 706.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 264.18,
    y1: 574.21,
    x2: 264.18,
    y2: 673.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    y1: 653.93,
    y2: 593.73,
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 264.18,
    y1: 682.04,
    x2: 264.18,
    y2: 567.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 264.18,
    y1: 607.68,
    x2: 264.18,
    y2: 642.15,
    gradientTransform: "translate(829.98 251.07) rotate(79.55)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 264.18,
    y1: 637.74,
    x2: 264.18,
    y2: 610.89,
    gradientTransform: "translate(829.85 250.87) rotate(79.53)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 926.45,
    y1: 550.01,
    x2: 926.45,
    y2: 556.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 926.45,
    y1: 555.88,
    x2: 926.45,
    y2: 561.59,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    y1: 561.75,
    y2: 567.19,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 926.45,
    y1: 567.51,
    x2: 926.45,
    y2: 572.83,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    y1: 572.94,
    y2: 578.7,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 926.45,
    y1: 578.91,
    x2: 926.45,
    y2: 584.9,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    y1: 585.22,
    y2: 590.22,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 926.45,
    y1: 590.43,
    x2: 926.45,
    y2: 595.65,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    y1: 596.62,
    y2: 601.73,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 926.45,
    y1: 602.49,
    x2: 926.45,
    y2: 607.6,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    y1: 608.14,
    y2: 614.04,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 926.45,
    y1: 614.44,
    x2: 926.45,
    y2: 619.34,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 906.51,
    y1: 549.96,
    x2: 906.51,
    y2: 626.18,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 946.38,
    y1: 549.96,
    x2: 946.38,
    y2: 626.18,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 807.95,
    x2: 807.95,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    x1: 807.95,
    x2: 807.95,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 807.95,
    x2: 807.95,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 807.92,
    y1: 573.42,
    x2: 807.92,
    y2: 673.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#68696b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#929495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 807.95,
    y1: 642.51,
    x2: 807.95,
    y2: 605.26,
    gradientTransform: "translate(677.94 -388.51) rotate(45)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 807.95,
    y1: 637.62,
    x2: 807.95,
    y2: 611,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-3",
    x1: 1044.64,
    x2: 1044.64,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-3",
    x1: 1044.64,
    x2: 1044.64,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 1044.64,
    x2: 1044.64,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 1044.61,
    x2: 1044.61,
    xlinkHref: "#linear-gradient-95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 1044.64,
    y1: 642.51,
    x2: 1044.64,
    y2: 605.26,
    gradientTransform: "translate(1412.03 -535.99) rotate(76.72)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 1044.64,
    y1: 637.62,
    x2: 1044.64,
    y2: 611,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 551.95,
    y1: 520.54,
    x2: 551.95,
    y2: 657.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#cccecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#bec0c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a8aaad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#919396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#818285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#757679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6e6f72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 459.91,
    y1: 640.48,
    x2: 459.91,
    y2: 665.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#212122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 551.95,
    x2: 551.95,
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 643.98,
    x2: 643.98,
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 586.62,
    y1: 525.3,
    x2: 611.02,
    y2: 525.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#28292a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#58595c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 1926.83,
    y1: 540.94,
    x2: 1926.83,
    y2: 457.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#9c9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#545152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 1300.98,
    y1: 670.46,
    x2: 1300.98,
    y2: 514.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e0001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-4",
    x1: 1300.98,
    y1: 683.23,
    x2: 1300.98,
    y2: 691.17,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-5",
    x1: 1300.98,
    y1: 651.72,
    x2: 1300.98,
    y2: 682.75,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-6",
    x1: 1300.98,
    y1: 495.78,
    x2: 1300.98,
    y2: 636.74,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-4",
    x1: 2842.95,
    x2: 2842.95,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-7",
    x1: 2842.95,
    x2: 2842.95,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 2842.95,
    x2: 2842.95,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 2842.92,
    x2: 2842.92,
    xlinkHref: "#linear-gradient-95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 2842.95,
    y1: 642.51,
    x2: 2842.95,
    y2: 605.26,
    gradientTransform: "translate(2797.17 -2286.19) rotate(76.72)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 2842.95,
    y1: 637.62,
    x2: 2842.95,
    y2: 611,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 2491.98,
    y1: 542.49,
    x2: 2491.98,
    y2: 462.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8d8f92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#6c6d6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#545456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#464547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 2485.04,
    x2: 2485.04,
    xlinkHref: "#linear-gradient-113"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 2498.93,
    x2: 2498.93,
    xlinkHref: "#linear-gradient-113"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 2720.56,
    x2: 2720.56,
    xlinkHref: "#linear-gradient-113"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 2720.56,
    x2: 2720.56,
    xlinkHref: "#linear-gradient-113"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 2713.62,
    x2: 2713.62,
    xlinkHref: "#linear-gradient-113"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 2727.5,
    x2: 2727.5,
    xlinkHref: "#linear-gradient-113"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 2942.19,
    x2: 2942.19,
    xlinkHref: "#linear-gradient-113"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 2956.08,
    x2: 2956.08,
    xlinkHref: "#linear-gradient-113"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 489.29,
    y1: 372.9,
    x2: 489.29,
    y2: 503.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e2e3e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#d9dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c8cacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-8",
    x1: 1848.9,
    y1: 502.52,
    x2: 1848.9,
    y2: 549.38,
    gradientTransform: "translate(1219.43)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: -7919.44,
    y1: -2036.28,
    x2: -7919.44,
    y2: -2017.84,
    gradientTransform: "translate(-4830.16 -1489.65) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15a29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 1869.85,
    y1: 505.05,
    x2: 1869.85,
    y2: 525.05,
    gradientTransform: "translate(1219.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-9",
    x1: 1852.27,
    y1: 479.38,
    x2: 1852.27,
    y2: 549.13,
    gradientTransform: "translate(1219.43)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-10",
    x1: 1860.27,
    y1: 458.4,
    x2: 1860.27,
    y2: 627.11,
    gradientTransform: "translate(1219.43)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-11",
    x1: 1860.27,
    y1: 574.52,
    x2: 1860.27,
    y2: 628.61,
    gradientTransform: "translate(1219.43)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 200.3,
    y1: 217.41,
    x2: 200.3,
    y2: 524.42,
    xlinkHref: "#linear-gradient-122"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 112.01,
    y1: 563.95,
    x2: 112.01,
    y2: 529.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#747577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8e8f91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a2a4a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#b1b2b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#b9bbbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b8babc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#adaeb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9a9b9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#807f81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5e5c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#353233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_11_cop",
    x1: 98.52,
    y1: 623.31,
    x2: 98.52,
    y2: 630.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#e3c8af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 34.17,
    y1: 524.27,
    x2: 34.17,
    y2: 632.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 1929.29,
    y1: 1.17,
    x2: 1929.29,
    y2: 491.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 230.39,
    y1: 435.65,
    x2: 230.39,
    y2: 419.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 210.85,
    y1: 424.06,
    x2: 210.85,
    y2: 431.19,
    xlinkHref: "#linear-gradient-127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 248.42,
    y1: 424.06,
    x2: 248.42,
    y2: 431.19,
    gradientTransform: "translate(496.84 854.93) rotate(180)",
    xlinkHref: "#linear-gradient-127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 229.64,
    y1: 425.01,
    x2: 229.64,
    y2: 430.15,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 86.54,
    y1: 504.11,
    x2: 86.54,
    y2: 515.29,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-123"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 9.42,
    y1: 360.52,
    x2: 20.21,
    y2: 392.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8b8f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9296a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9ea1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#afb2bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9a9daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f867e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#938167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 14.66,
    y1: 264.83,
    x2: 14.66,
    y2: 356.09,
    xlinkHref: "#linear-gradient-134"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: -15037.09,
    y1: 500.41,
    x2: -15037.09,
    y2: 488.97,
    gradientTransform: "translate(17978.87 989.12) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be1e2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: -15051.78,
    y1: 488.86,
    x2: -15051.78,
    y2: 500.92,
    gradientTransform: "translate(18008.25 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-123"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: -14322.99,
    x2: -14322.99,
    gradientTransform: "translate(16550.68 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-136"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: -14337.68,
    y1: 488.86,
    x2: -14337.68,
    y2: 500.92,
    gradientTransform: "translate(16580.06 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-123"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: -13608.89,
    x2: -13608.89,
    gradientTransform: "translate(15122.48 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-136"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: -13623.58,
    y1: 488.86,
    x2: -13623.58,
    y2: 500.92,
    gradientTransform: "translate(15151.86 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-123"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: -12894.79,
    x2: -12894.79,
    gradientTransform: "translate(13694.28 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-136"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: -12909.48,
    y1: 488.86,
    x2: -12909.48,
    y2: 500.92,
    gradientTransform: "translate(13723.66 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-123"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 1622.81,
    y1: 666.29,
    x2: 1622.81,
    y2: 605.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 1916.67,
    x2: 1916.67,
    xlinkHref: "#linear-gradient-144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 2210.52,
    x2: 2210.52,
    xlinkHref: "#linear-gradient-144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 1769.74,
    y1: 662.69,
    x2: 1769.74,
    y2: 494.97,
    xlinkHref: "#linear-gradient-144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 2063.59,
    y1: 662.69,
    x2: 2063.59,
    y2: 494.97,
    xlinkHref: "#linear-gradient-144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: -14274.98,
    y1: 612.6,
    x2: -14274.98,
    gradientTransform: "translate(-12358.31) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: -14274.98,
    y1: 558.92,
    x2: -14274.98,
    y2: 551.73,
    gradientTransform: "translate(-12358.31) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: -14274.98,
    x2: -14274.98,
    y2: 494.97,
    gradientTransform: "translate(-12358.31) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-144"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-195"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-194",
    width: 3096,
    height: 89,
    transform: "translate(-.21 715.22)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M524.93,362.33c4.02,6.3,6.17,13.77,6.17,21.43v34.67c0,7.66-2.15,15.13-6.17,21.43l-6,9.4v-96.32l6,9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M524.93,362.33c4.02,6.3,6.17,13.77,6.17,21.43v34.67c0,7.66-2.15,15.13-6.17,21.43l-6,9.4v-96.32l6,9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M521.18,343.85h0v114.5h0c-3.04,0-5.5-2.47-5.5-5.5v-103.5c0-3.04,2.47-5.5,5.5-5.5Z",
    transform: "translate(1036.86 802.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M458.8,315.09l4.39-6.29h48.83l4.39,6.29c1.64,2.35,2.54,5.28,2.54,8.3v155.42c0,3.01-.89,5.94-2.54,8.3l-4.39,6.29h-48.83l-4.39-6.29c-1.64-2.35-2.54-5.28-2.54-8.3v-155.42c0-3.02.89-5.94,2.54-8.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 463.19,
    y: 308.8,
    width: 48.83,
    height: 184.59,
    transform: "translate(975.2 802.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 463.19,
    y: 492.08,
    width: 5.86,
    height: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 463.19,
    y: 489.31,
    width: 5.86,
    height: 1.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 463.19,
    y: 486,
    width: 5.86,
    height: 1.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 463.19,
    y: 481.97,
    width: 5.86,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 463.19,
    y: 477.26,
    width: 5.86,
    height: 2.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 463.19,
    y: 472.09,
    width: 5.86,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 463.19,
    y: 466.3,
    width: 5.86,
    height: 3.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 463.19,
    y: 460.14,
    width: 5.86,
    height: 3.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 463.19,
    y: 453.37,
    width: 5.86,
    height: 3.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 463.19,
    y: 446.29,
    width: 5.86,
    height: 4.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 463.19,
    y: 438.78,
    width: 5.86,
    height: 4.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 463.19,
    y: 430.98,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 463.19,
    y: 422.97,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 463.19,
    y: 414.74,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 463.19,
    y: 406.52,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 463.19,
    y: 308.8,
    width: 5.86,
    height: 1.31,
    transform: "translate(932.23 618.91) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 463.19,
    y: 311.18,
    width: 5.86,
    height: 1.71,
    transform: "translate(932.23 624.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 463.19,
    y: 314.23,
    width: 5.86,
    height: 1.96,
    transform: "translate(932.23 630.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 463.19,
    y: 317.85,
    width: 5.86,
    height: 2.38,
    transform: "translate(932.23 638.08) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 463.19,
    y: 322.14,
    width: 5.86,
    height: 2.79,
    transform: "translate(932.23 647.07) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 463.19,
    y: 327.05,
    width: 5.86,
    height: 3.05,
    transform: "translate(932.23 657.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 463.19,
    y: 332.43,
    width: 5.86,
    height: 3.46,
    transform: "translate(932.23 668.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 463.19,
    y: 338.38,
    width: 5.86,
    height: 3.67,
    transform: "translate(932.23 680.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 463.19,
    y: 344.94,
    width: 5.86,
    height: 3.88,
    transform: "translate(932.23 693.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 463.19,
    y: 351.72,
    width: 5.86,
    height: 4.19,
    transform: "translate(932.23 707.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 463.19,
    y: 359.07,
    width: 5.86,
    height: 4.34,
    transform: "translate(932.23 722.49) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 463.19,
    y: 366.58,
    width: 5.86,
    height: 4.63,
    transform: "translate(932.23 737.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 463.19,
    y: 374.6,
    width: 5.86,
    height: 4.63,
    transform: "translate(932.23 753.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 463.19,
    y: 382.61,
    width: 5.86,
    height: 4.83,
    transform: "translate(932.23 770.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 463.19,
    y: 390.84,
    width: 5.86,
    height: 4.83,
    transform: "translate(932.23 786.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 463.19,
    y: 398.72,
    width: 5.86,
    height: 4.76,
    transform: "translate(932.23 802.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 506.16,
    y: 492.08,
    width: 5.86,
    height: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 506.16,
    y: 489.31,
    width: 5.86,
    height: 1.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 506.16,
    y: 486,
    width: 5.86,
    height: 1.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 506.16,
    y: 481.97,
    width: 5.86,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 506.16,
    y: 477.26,
    width: 5.86,
    height: 2.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 506.16,
    y: 472.09,
    width: 5.86,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 506.16,
    y: 466.3,
    width: 5.86,
    height: 3.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 506.16,
    y: 460.14,
    width: 5.86,
    height: 3.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 506.16,
    y: 453.37,
    width: 5.86,
    height: 3.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 506.16,
    y: 446.29,
    width: 5.86,
    height: 4.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 506.16,
    y: 438.78,
    width: 5.86,
    height: 4.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 506.16,
    y: 430.98,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 506.16,
    y: 422.97,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 506.16,
    y: 414.74,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 506.16,
    y: 406.52,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 506.16,
    y: 308.8,
    width: 5.86,
    height: 1.31,
    transform: "translate(1018.17 618.91) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 506.16,
    y: 311.18,
    width: 5.86,
    height: 1.71,
    transform: "translate(1018.17 624.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 506.16,
    y: 314.23,
    width: 5.86,
    height: 1.96,
    transform: "translate(1018.17 630.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 506.16,
    y: 317.85,
    width: 5.86,
    height: 2.38,
    transform: "translate(1018.17 638.08) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 506.16,
    y: 322.14,
    width: 5.86,
    height: 2.79,
    transform: "translate(1018.17 647.07) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 506.16,
    y: 327.05,
    width: 5.86,
    height: 3.05,
    transform: "translate(1018.17 657.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 506.16,
    y: 332.43,
    width: 5.86,
    height: 3.46,
    transform: "translate(1018.17 668.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 506.16,
    y: 338.38,
    width: 5.86,
    height: 3.67,
    transform: "translate(1018.17 680.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 506.16,
    y: 344.94,
    width: 5.86,
    height: 3.88,
    transform: "translate(1018.17 693.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 506.16,
    y: 351.72,
    width: 5.86,
    height: 4.19,
    transform: "translate(1018.17 707.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 506.16,
    y: 359.07,
    width: 5.86,
    height: 4.34,
    transform: "translate(1018.17 722.49) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 506.16,
    y: 366.58,
    width: 5.86,
    height: 4.63,
    transform: "translate(1018.17 737.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 506.16,
    y: 374.6,
    width: 5.86,
    height: 4.63,
    transform: "translate(1018.17 753.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 506.16,
    y: 382.61,
    width: 5.86,
    height: 4.83,
    transform: "translate(1018.17 770.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 506.16,
    y: 390.84,
    width: 5.86,
    height: 4.83,
    transform: "translate(1018.17 786.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 506.16,
    y: 398.72,
    width: 5.86,
    height: 4.76,
    transform: "translate(1018.17 802.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 468.02,
    y: 308.8,
    width: 39.17,
    height: 184.59,
    transform: "translate(975.2 802.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M499.67,326.29l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M490.21,326.29l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M480.76,326.29l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M471.3,326.29l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M529.81,505.71c-.4,0-.8,0-1.2-.01-1.1-.03-1.98-.94-1.95-2.04.02-1.1.93-1.9,2.04-1.95,14.41.3,22.48-5.62,30.31-11.36,6.51-4.77,12.66-9.28,21.69-9.85,7.28-.48,11.62,2.91,15.11,5.62,2.76,2.14,4.42,3.34,6.47,2.92,3.09-.62,3.27-3.4,2.52-9.79-.5-4.31-1.13-9.67,3.57-10.39,4.27-.68,6.5,3.43,8.63,7.39,2.47,4.57,4.44,7.82,7.97,7.72.99-.02,1.36-.32,1.55-.54,1.09-1.25.68-4.94.34-7.91-.51-4.55-1.15-10.22,3.71-10.88,4.66-.65,7.01,4.69,9.28,9.85,1.66,3.77,3.73,8.47,6.06,8.52.37-.01.5-.1.57-.17,1.06-1.06.99-5.26.94-8.32-.09-5.25-.19-11.19,4.55-11.34.05,0,.1,0,.15,0,4.68,0,7.01,6.57,9.07,12.38.6,1.68,1.43,4.02,2.1,5.3.67-1.47,1.45-4.25,2.02-6.25,1.86-6.61,3.63-12.86,7.9-12.86h.03c4.15.03,4.54,5.27,4.95,10.82.29,3.87.72,9.73,2.72,9.78h.03c2.06,0,3.67-5.09,4.84-8.81,1.67-5.29,3.54-11.27,8.42-10.31,4.74.94,5.3,6.57,5.8,11.54.32,3.17.71,7.11,2.19,7.74,1.32.56,2.97-.83,5.53-3.2,2.94-2.73,6.6-6.12,11.45-5.5,4.14.52,6.28,2.17,8.54,3.93,4.83,3.75,11.47,8.88,47.1,7.28,1.16-.08,2.04.8,2.09,1.91.05,1.1-.8,2.03-1.91,2.08-37.13,1.67-44.41-3.99-49.73-8.12-2.05-1.59-3.53-2.73-6.58-3.12-2.98-.37-5.67,2.08-8.23,4.47-2.82,2.62-6.02,5.59-9.83,3.95-3.64-1.56-4.12-6.37-4.59-11.02-.36-3.59-.77-7.65-2.6-8.02-1.34-.29-2.89,4.66-3.82,7.59-1.74,5.5-3.74,11.75-8.78,11.6-5.62-.14-6.17-7.54-6.61-13.48-.17-2.3-.45-6.07-1.1-7.06-1.37.78-3.1,6.9-3.94,9.89-1.67,5.93-2.78,9.87-5.79,9.87h-.05c-2.83-.04-4.12-3.65-5.89-8.66-1.21-3.4-3.45-9.71-5.31-9.71h-.02c-.78.63-.71,4.95-.67,7.27.08,4.61.15,8.97-2.12,11.23-.91.91-2.06,1.33-3.49,1.33-4.86-.12-7.28-5.61-9.62-10.91-1.52-3.44-3.45-7.65-5.09-7.5-.99.13-.54,4.1-.27,6.47.46,4.13.94,8.4-1.3,10.98-1.06,1.22-2.56,1.86-4.46,1.91-6.19.23-9.19-5.37-11.59-9.81-1.82-3.36-3.1-5.58-4.51-5.34-.89.14-.48,3.65-.21,5.98.59,5.07,1.49,12.73-5.7,14.18-3.94.78-6.88-1.49-9.71-3.68-3.26-2.53-6.62-5.14-12.41-4.79-7.86.5-13.29,4.49-19.58,9.09-7.78,5.7-16.57,12.14-31.56,12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M958.81,509.19l-27.97-22.56c-2.73-2.2-6.62-2.2-9.35,0l-27.97,22.56h-33.9c-6.33,0-11.46,5.13-11.46,11.46v11.69h147.25v-11.69c0-6.33-5.13-11.46-11.46-11.46h-25.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M932.92,513.27l19.11-20.59h-50.39l19.11,20.59c3.28,3.54,8.88,3.54,12.17,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "996.09 496.16 864.01 496.16 864.01 484.97 957.64 484.97 996.09 491.94 996.09 496.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 880.55,
    y: 484.97,
    width: 77.09,
    height: 11.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M932.91,506.37c0,3.36-2.72,6.08-6.08,6.08s-6.08-2.72-6.08-6.08,2.72-6.08,6.08-6.08,6.08,2.72,6.08,6.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 1302.62,
    y: 473.88,
    width: 1783.93,
    height: 92.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M767.11,457.44v32.86h372.22c31.92,0,63.73,3.82,94.74,11.38l116.64,28.43c29.5,7.19,59.75,10.82,90.11,10.82h1645.73v-83.49H767.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M723.03,518.59l-27.09-21.79h-307.63v-48.27c0-13.61-11.03-24.64-24.64-24.64H62.14v167.59h61.44c14.98,0,29.61,3,42.31,8.66,16.52,7.38,35.51,11.27,54.92,11.27h99.68c8.66,0,17.34-.82,25.76-2.37,7.53,6.08,15.39,10.05,23.09,10.05h166.1c13.48,0,23.04-3.25,34.11-7.01,13.11-4.46,81.45-7.26,81.45-7.26h253.64c4.84,0,9.69-1.17,13.69-3.89,3.73-2.53,8.13-3.88,12.63-3.88h256.42v-45.15c0-2.01-1.09-3.85-2.84-4.83h0c-33.67-18.68-98.95-28.49-137.46-28.49h-324.04ZM320.48,592.12h-99.68c-14.98,0-29.61-3-42.31-8.67-5.98-2.67-12.3-4.87-18.83-6.61h158.75c3.36,4.97,7.05,10.06,10.98,14.91-2.96.24-5.94.36-8.91.36ZM343.95,589.58c-3.45-3.87-6.88-8.18-10.22-12.73h50.23c-3.18.84-6.31,1.77-9.35,2.83l-19.12,6.66c-3.72,1.3-7.59,2.37-11.55,3.23ZM565.53,600.26c-10.84,3.68-18.68,6.35-30.09,6.35h-166.1c-2.12,0-4.37-.59-6.7-1.63,1.08-.34,2.17-.67,3.23-1.04l19.12-6.67c10.84-3.78,22.95-5.78,35.02-5.78h112.83l48.32,3.77c-5.91,1.7-10.98,3.42-15.62,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M388.31,481.12h0c-2.95,0-5.34-2.39-5.34-5.34v-178.18c0-2.95,2.39-5.34,5.34-5.34h0c2.95,0,5.34,2.39,5.34,5.34v178.18c0,2.95-2.39,5.34-5.34,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M251.48,316.24c1.74-2.14,2.66-4.94,2.3-7.88l-2.46-19.75c-.71-5.71-5.96-9.8-11.67-9.09l-.34.04c-5.71.71-9.8,5.96-9.09,11.67l2.46,19.75c.37,2.96,1.98,5.47,4.22,7.12-4.18,2.64-7.24,7.01-8,12.25l-8.48,58.55c-1.38,9.51,5.27,18.41,14.78,19.79,9.51,1.38,18.41-5.27,19.79-14.78l8.48-58.55c1.24-8.54-4.01-16.58-11.99-19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M87.88,356.38c-.2,1.92,1.18,3.66,3.04,4.16l23.56,6.41-2.76,10.14c-.38,1.39-1.81,2.21-3.2,1.83h0c-.95-.26-1.92.3-2.18,1.25l-14.33,52.66,21.4,5.82,14.33-52.66c.26-.95-.3-1.92-1.25-2.18h0c-1.39-.38-2.21-1.81-1.83-3.2l2.76-10.14,23.56,6.41c1.86.51,3.93-.3,4.73-2.05,1.02-2.24-.23-4.75-2.5-5.36l-60.46-16.45c-2.27-.62-4.61.92-4.87,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M125.5,259.98h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 274.8,
    y: 259.98,
    width: 63.55,
    height: 113.32,
    rx: 11.09,
    ry: 11.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M274.8,345.32v16.89c0,6.13,4.97,11.09,11.09,11.09h41.37c6.13,0,11.09-4.97,11.09-11.09v-16.89h-63.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M138.01,356.95l-5.79,8.81c-3.08,4.7-8.33,7.53-13.95,7.53h-39.42c-1.09,8.59-1.8,17.08-2.14,25.56-.47,11.93,10.7,20.94,22.24,17.9l127.56-33.59c9.13-2.4,15.5-10.66,15.5-20.11v-17.75h-82.45c-8.69,0-16.79,4.37-21.56,11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M369.19,526.98v108.78c0,15.09,1.6,18.96,6.78,30.3,3.46,7.57,10.51,12.35,17.74,8.88l3.55-1.7c1.69-.81,1.82-3.33.19-4.28-6.07-3.52-23.11-6.5-24.13-33.68-1.62-43.08.07-113.48-4.13-108.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M414.27,448.39h-24.76v-33.44c0-4.01-3.25-7.26-7.26-7.26s-7.26,3.25-7.26,7.26v70.4c0,4.26,3.45,7.71,7.71,7.71h31.58c4.26,0,7.71-3.45,7.71-7.71v-29.25c0-4.26-3.45-7.71-7.71-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M399,478.27h24.76v33.44c0,4.01,3.25,7.26,7.26,7.26s7.26-3.25,7.26-7.26v-70.4c0-4.26-3.45-7.71-7.71-7.71h-31.58c-4.26,0-7.71,3.45-7.71,7.71v29.25c0,4.26,3.45,7.71,7.71,7.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-142",
    cx: 414.79,
    cy: 461.49,
    r: 34.46,
    transform: "translate(-163.67 236.95) rotate(-26.84)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-140",
    cx: 414.79,
    cy: 461.49,
    r: 27.78,
    transform: "translate(-204.84 428.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-141",
    cx: 414.79,
    cy: 461.49,
    r: 21.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-143",
    cx: 414.79,
    cy: 461.49,
    r: 17.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M399.44,285.6c0-4.55-3.69-8.23-8.23-8.23s-8.23,3.69-8.23,8.23v49.12h16.47v-49.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M264.18,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM264.18,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M356.47,626.8v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.63-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.23-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM264.18,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M264.18,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM264.18,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M314.06,632.33c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.64-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.05,5.16,6.05,11.52s-2.71,11.52-6.05,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.57-1.17,2.99-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43,4.5-4.5,10.06-6.23,12.43-3.86,1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-134",
    cx: 264.18,
    cy: 624.09,
    r: 31.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M264.18,573.43c-27.98,0-50.66,22.68-50.66,50.66s22.68,50.66,50.66,50.66,50.66-22.68,50.66-50.66-22.68-50.66-50.66-50.66ZM264.18,671.7c-26.29,0-47.61-21.31-47.61-47.61s21.31-47.61,47.61-47.61,47.61,21.31,47.61,47.61-21.31,47.61-47.61,47.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M264.18,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM264.18,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M314.06,632.33c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.64-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.05,5.16,6.05,11.52s-2.71,11.52-6.05,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.57-1.17,2.99-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43,4.5-4.5,10.06-6.23,12.43-3.86,1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M264.18,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM264.18,673.04c-27.04,0-48.95-21.92-48.95-48.95s21.92-48.95,48.95-48.95,48.95,21.92,48.95,48.95-21.92,48.95-48.95,48.95Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-131",
    cx: 264.18,
    cy: 624.09,
    r: 18.8,
    transform: "translate(-397.49 770.65) rotate(-79.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "266.65 645.21 262.48 645.21 260.39 648.82 262.48 652.44 266.65 652.44 268.74 648.82 266.65 645.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M266.61,648.82c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "280.86 637.28 277.91 640.23 278.99 644.25 283.02 645.33 285.97 642.38 284.89 638.35 280.86 637.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M283.39,639.86c.8.8.8,2.1,0,2.89s-2.09.8-2.89,0c-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "285.3 621.62 285.3 625.79 288.91 627.87 292.52 625.79 292.52 621.62 288.91 619.53 285.3 621.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M288.91,621.66c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "277.36 607.41 280.31 610.36 284.34 609.28 285.42 605.25 282.47 602.3 278.44 603.38 277.36 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M279.94,604.88c.8-.8,2.09-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "261.7 602.97 265.87 602.97 267.96 599.36 265.87 595.74 261.7 595.74 259.62 599.36 261.7 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M261.74,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "247.49 610.91 250.44 607.96 249.36 603.93 245.33 602.85 242.38 605.8 243.46 609.83 247.49 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M244.96,608.32c-.8-.8-.8-2.1,0-2.89.8-.8,2.09-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "243.05 626.56 243.05 622.39 239.44 620.31 235.83 622.39 235.83 626.56 239.44 628.65 243.05 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M239.44,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "250.99 640.77 248.04 637.82 244.01 638.9 242.93 642.93 245.88 645.88 249.91 644.8 250.99 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M248.41,643.3c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0,.8,2.09,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-130",
    cx: 264.18,
    cy: 624.09,
    r: 13.3,
    transform: "translate(-397.54 770.42) rotate(-79.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M945.35,598.46l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-170",
    cx: 808.19,
    cy: 624.09,
    r: 39.87,
    transform: "translate(15.11 1267.28) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M1181.81,598.46l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-170",
    cx: 1044.65,
    cy: 624.09,
    r: 39.87,
    transform: "translate(261.29 1555.29) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 893.73,
    y: 549.91,
    width: 65.43,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 885.83,
    y: 555.7,
    width: 81.24,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 877.92,
    y: 561.5,
    width: 97.06,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 870.01,
    y: 567.3,
    width: 112.87,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 862.1,
    y: 573.1,
    width: 128.68,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 854.2,
    y: 578.9,
    width: 144.5,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 846.29,
    y: 584.69,
    width: 160.31,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 838.38,
    y: 590.49,
    width: 176.12,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 830.48,
    y: 596.29,
    width: 191.94,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 822.57,
    y: 602.09,
    width: 207.75,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 814.66,
    y: 607.88,
    width: 223.57,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 806.76,
    y: 613.68,
    width: 239.38,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 902.91,
    y: 548.65,
    width: 7.19,
    height: 72.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 942.78,
    y: 548.65,
    width: 7.19,
    height: 72.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M907.62,613.47l7.54,34.13c.42,1.9,1.44,3.14,2.58,3.14h17.42c1.14,0,2.16-1.25,2.58-3.14l7.54-34.13c.72-3.26-.62-6.8-2.58-6.8h-32.49c-1.96,0-3.3,3.54-2.58,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M907.74,632.92c-4.44.38-8.02,3.25-9.6,7.11l-100.9,8.57.88,10.35,100.9-8.57c2.21,3.53,6.23,5.77,10.66,5.39,6.31-.54,10.99-6.09,10.46-12.4-.54-6.31-6.09-10.99-12.4-10.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M945.15,632.92c4.44.38,8.02,3.25,9.6,7.11l100.9,8.57-.88,10.35-100.9-8.57c-2.21,3.53-6.23,5.77-10.66,5.39-6.31-.54-10.99-6.09-10.46-12.4s6.09-10.99,12.4-10.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M1188.55,670.56c-6.08-2.73-23.11-5.04-24.13-26.15-.48-9.85-.67-45.37-.81-56.86h-3.32v57.23c0,11.72,1.6,14.72,6.78,23.52,3.47,5.88,10.51,9.59,17.74,6.9l3.55-1.32c1.69-.63,1.82-2.59.19-3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M923.5,624.09h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M917.26,624.09h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1160.28,624.09h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M1154.04,624.09h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-170",
    cx: 808.19,
    cy: 624.09,
    r: 39.87,
    transform: "translate(15.11 1267.28) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M807.95,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM807.95,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M900.24,626.8v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.86-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.63-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM807.95,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M807.95,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM807.95,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M807.95,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM807.95,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M807.95,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM807.95,672.19c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M807.92,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM775.15,591.54c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM767.11,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27ZM786.42,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08s7.07-.57,11.08,3.45,5.56,8.98,3.45,11.09ZM807.79,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM808.05,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM829.42,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM840.68,656.71c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08,8.98-5.56,11.08-3.45c2.11,2.11.57,7.07-3.45,11.08ZM848.73,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M857.95,617.52c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.28,5.4-10.28s5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM782.79,599.18c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45s.57,7.07-3.45,11.08ZM807.79,588.71c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.28,2.42,10.28,5.4-4.6,5.4-10.28,5.4ZM843.95,602.44c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M772.74,603.28c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM807.79,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M807.92,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM775.15,591.54c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM767.11,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27ZM786.42,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08s7.07-.57,11.08,3.45,5.56,8.98,3.45,11.09ZM807.79,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM808.05,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM829.42,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM840.68,656.71c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08,8.98-5.56,11.08-3.45c2.11,2.11.57,7.07-3.45,11.08ZM848.73,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "810.42 645.21 806.25 645.21 804.16 648.82 806.25 652.44 810.42 652.44 812.51 648.82 810.42 645.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M810.38,648.82c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "824.63 637.28 821.68 640.23 822.76 644.25 826.79 645.33 829.74 642.38 828.66 638.35 824.63 637.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M827.16,639.86c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "829.07 621.62 829.07 625.79 832.68 627.87 836.29 625.79 836.29 621.62 832.68 619.53 829.07 621.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M832.68,621.66c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "821.13 607.41 824.08 610.36 828.11 609.28 829.19 605.25 826.24 602.3 822.21 603.38 821.13 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M823.71,604.88c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.09.8-2.89,0-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "805.47 602.97 809.64 602.97 811.73 599.36 809.64 595.74 805.47 595.74 803.39 599.36 805.47 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M805.51,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "791.26 610.91 794.21 607.96 793.13 603.93 789.1 602.85 786.15 605.8 787.23 609.83 791.26 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M788.74,608.32c-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0c.8.8.8,2.1,0,2.89s-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "786.83 626.56 786.83 622.39 783.21 620.31 779.6 622.39 779.6 626.56 783.21 628.65 786.83 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M783.21,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "794.76 640.77 791.81 637.82 787.78 638.9 786.7 642.93 789.65 645.88 793.68 644.8 794.76 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M792.18,643.3c-.8.8-2.09.8-2.89,0-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0c.8.8.8,2.09,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-159",
    cx: 807.95,
    cy: 624.09,
    r: 18.8,
    transform: "translate(-204.66 754.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-160",
    cx: 807.95,
    cy: 624.09,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M1044.64,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM1044.64,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1136.94,626.8v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.63-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.23,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.59,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM1044.64,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1044.64,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM1044.64,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M1044.64,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM1044.64,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M1044.64,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM1044.64,672.19c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M1044.61,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM1011.84,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM1003.8,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27ZM1023.11,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45s5.56,8.98,3.45,11.09ZM1044.48,577.91c5.68,0,10.28,2.42,10.28,5.4s-4.6,5.4-10.28,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1044.74,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1066.11,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1077.38,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1085.42,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M1094.65,617.52c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.28,5.4-10.28s5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM1019.48,599.18c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1044.48,588.71c-5.67,0-10.28-2.42-10.28-5.4s4.6-5.4,10.28-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1080.64,602.44c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M1009.44,603.28c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM1044.48,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1044.61,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM1011.84,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM1003.8,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27ZM1023.11,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45s5.56,8.98,3.45,11.09ZM1044.48,577.91c5.68,0,10.28,2.42,10.28,5.4s-4.6,5.4-10.28,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1044.74,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1066.11,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1077.38,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1085.42,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "1047.12 645.21 1042.95 645.21 1040.86 648.82 1042.95 652.44 1047.12 652.44 1049.2 648.82 1047.12 645.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M1047.08,648.82c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "1061.33 637.28 1058.38 640.23 1059.46 644.25 1063.49 645.33 1066.44 642.38 1065.36 638.35 1061.33 637.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M1063.85,639.86c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.09-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "1065.76 621.62 1065.76 625.79 1069.38 627.87 1072.99 625.79 1072.99 621.62 1069.38 619.53 1065.76 621.62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-167",
    cx: 1069.38,
    cy: 623.7,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "1057.83 607.41 1060.78 610.36 1064.81 609.28 1065.89 605.25 1062.94 602.3 1058.91 603.38 1057.83 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M1060.41,604.88c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "1042.17 602.97 1046.34 602.97 1048.43 599.36 1046.34 595.74 1042.17 595.74 1040.08 599.36 1042.17 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M1042.21,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "1027.96 610.91 1030.91 607.96 1029.83 603.93 1025.8 602.85 1022.85 605.8 1023.93 609.83 1027.96 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M1025.43,608.32c-.8-.8-.8-2.1,0-2.89.8-.8,2.09-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "1023.52 626.56 1023.52 622.39 1019.91 620.31 1016.3 622.39 1016.3 626.56 1019.91 628.65 1023.52 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M1019.91,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "1031.46 640.77 1028.51 637.82 1024.48 638.9 1023.4 642.93 1026.35 645.88 1030.38 644.8 1031.46 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M1028.88,643.3c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0s.8,2.09,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 1044.64,
    cy: 624.09,
    r: 18.8,
    transform: "translate(197.24 1497.4) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-35",
    cx: 1044.64,
    cy: 624.09,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1149.99,571.72c5.24,10.56,8.91,22.04,10.71,34.12.32,2.15,2.12,3.77,4.29,3.77h14.06v-47.75h-23c-5.07,0-8.31,5.32-6.05,9.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1178.11,587.56h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.71-2.56-5.71-5.71v-7.36c0-3.16,2.56-5.71,5.71-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 1178.76,
    y: 588.96,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1178.87,
    y: 589.28,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 1177.05,
    y: 588.96,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1177.16,
    y: 589.28,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 1175.34,
    y: 588.96,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1175.45,
    y: 589.28,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1178.11,565.13h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.71-2.56-5.71-5.72v-7.36c0-3.16,2.56-5.71,5.71-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 1178.76,
    y: 566.54,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 1178.87,
    y: 566.85,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 1177.05,
    y: 566.54,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 1177.16,
    y: 566.85,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 1175.34,
    y: 566.54,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 1175.45,
    y: 566.85,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M428.59,518.59h246.72c2.96,0,5.36,2.4,5.36,5.36v127.75c0,2.96-2.4,5.36-5.36,5.36h-246.72c-2.96,0-5.36-2.4-5.36-5.36v-127.75c0-2.96,2.4-5.36,5.36-5.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 439.31,
    y: 640.12,
    width: 41.2,
    height: 25.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 453.82,
    y: 513.72,
    width: 12.19,
    height: 149.2,
    rx: 4.88,
    ry: 4.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M459.91,662.92h0c-2.15,0-3.9-1.75-3.9-3.9v-141.4c0-2.15,1.75-3.9,3.9-3.9h0c2.15,0,3.9,1.75,3.9,3.9v141.4c0,2.15-1.75,3.9-3.9,3.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 531.35,
    y: 640.12,
    width: 41.2,
    height: 25.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 545.85,
    y: 513.72,
    width: 12.19,
    height: 149.2,
    rx: 4.88,
    ry: 4.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M551.95,662.92h0c-2.15,0-3.9-1.75-3.9-3.9v-141.4c0-2.15,1.75-3.9,3.9-3.9h0c2.15,0,3.9,1.75,3.9,3.9v141.4c0,2.15-1.75,3.9-3.9,3.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 623.38,
    y: 640.12,
    width: 41.2,
    height: 25.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 637.89,
    y: 513.72,
    width: 12.19,
    height: 149.2,
    rx: 4.88,
    ry: 4.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M643.98,662.92h0c-2.15,0-3.9-1.75-3.9-3.9v-141.4c0-2.15,1.75-3.9,3.9-3.9h0c2.15,0,3.9,1.75,3.9,3.9v141.4c0,2.15-1.75,3.9-3.9,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M586.62,517.17h24.4v6.06c0,5.63-4.57,10.2-10.2,10.2h-4.01c-5.63,0-10.2-4.57-10.2-10.2v-6.06h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-166",
    cx: 598.82,
    cy: 517.17,
    rx: 12.2,
    ry: 8.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-189",
    cx: 598.82,
    cy: 515.52,
    rx: 10.48,
    ry: 6.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-74",
    cx: 1148.05,
    cy: 555.37,
    r: 6.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M2986.66,685.74c-6.08-2.73-23.11-5.04-24.13-26.14-.48-9.85-.67-34.51-.81-46h-3.32v46.37c0,11.72,1.6,14.72,6.78,23.52,3.47,5.88,10.51,9.59,17.74,6.9l3.55-1.32c1.69-.63,1.82-2.59.19-3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M767.11,457.44v32.86h372.22c31.92,0,63.73,3.82,94.74,11.38l116.64,28.43c29.5,7.19,59.75,10.82,90.11,10.82h1645.73v-83.49H767.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 1298.46,
    y: 583.16,
    width: 97.35,
    height: 11.6,
    transform: "translate(-21.89 1125.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 1289.1,
    y: 510.52,
    width: 23.76,
    height: 163.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1266.14,683.19h69.68v3.54c0,2.51-2.04,4.55-4.55,4.55h-60.58c-2.51,0-4.55-2.04-4.55-4.55v-3.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1293.38,655.93l-15.72,27.23h46.63l-15.72-27.23c-3.38-5.85-11.82-5.85-15.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M1306.22,662.9c0,2.9-2.35,5.25-5.25,5.25s-5.25-2.35-5.25-5.25,2.35-5.25,5.25-5.25,5.25,2.35,5.25,5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1292.53,494.97h16.9c7.16,0,12.98,5.82,12.98,12.98v130.64h-42.86v-130.64c0-7.16,5.82-12.98,12.98-12.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1296.51,512.29c0,3.31-2.68,6-6,6s-6-2.68-6-6,2.68-6,6-6,6,2.68,6,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1314.61,530.39c0,3.31-2.68,6-6,6s-6-2.68-6-6,2.68-6,6-6,6,2.68,6,6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2715.96,
    y: 615.16,
    width: 88.38,
    height: 8.74,
    transform: "translate(280.81 -742.49) rotate(16.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2728.32,
    y: 615.16,
    width: 88.38,
    height: 8.74,
    transform: "translate(281.29 -745.93) rotate(16.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M2952.63,579.05l-4.43-8.5c-2.04-3.9-6.85-5.42-10.76-3.38h0c-3.9,2.04-5.42,6.85-3.38,10.76l2.61,5h-86.63v-.37h-14.17v.37h-86.63l2.61-5c2.04-3.9.52-8.72-3.38-10.76h0c-3.9-2.04-8.72-.52-10.76,3.38l-4.43,8.5c-2.04,3.9-.52,8.72,3.38,10.75h0c3.52,1.84,7.76.77,10.06-2.32h20.08v2.28h7.89v2.28h12.5v2.28h13.82v2.28h17.77v2.28h17.08v1.49h14.17v-1.49h17.08v-2.28h17.77v-2.28h13.82v-2.28h12.5v-2.28h7.89v-2.28h20.08c2.3,3.09,6.54,4.16,10.06,2.32h0c3.91-2.04,5.42-6.85,3.38-10.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-170",
    cx: 2843.2,
    cy: 624.09,
    r: 39.87,
    transform: "translate(1771.74 3330.61) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M2842.95,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM2842.95,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2935.25,626.8v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.63-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM2842.95,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2842.95,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM2842.95,671.19c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M2842.95,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM2842.95,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M2842.95,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM2842.95,672.19c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M2842.92,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2810.15,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2802.11,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27ZM2821.42,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08s7.07-.57,11.08,3.45,5.56,8.98,3.45,11.09ZM2842.79,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4ZM2843.05,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2864.42,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2875.69,656.71c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2883.73,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M2892.96,617.52c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.28,5.4-10.28s5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM2817.79,599.18c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45s.57,7.07-3.45,11.08ZM2842.79,588.71c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2878.95,602.44c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M2807.75,603.28c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM2842.79,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M2842.92,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2810.15,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2802.11,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27ZM2821.42,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08s7.07-.57,11.08,3.45,5.56,8.98,3.45,11.09ZM2842.79,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4ZM2843.05,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2864.42,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2875.69,656.71c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2883.73,634.27c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "2845.42 645.21 2841.25 645.21 2839.17 648.82 2841.25 652.44 2845.42 652.44 2847.51 648.82 2845.42 645.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M2845.39,648.82c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "2859.63 637.28 2856.68 640.23 2857.76 644.25 2861.79 645.33 2864.74 642.38 2863.66 638.35 2859.63 637.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M2862.16,639.86c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.09-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "2864.07 621.62 2864.07 625.79 2867.68 627.87 2871.3 625.79 2871.3 621.62 2867.68 619.53 2864.07 621.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M2867.68,621.66c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "2856.14 607.41 2859.09 610.36 2863.11 609.28 2864.19 605.25 2861.24 602.3 2857.21 603.38 2856.14 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M2858.72,604.88c.8-.8,2.09-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "2840.48 602.97 2844.65 602.97 2846.73 599.36 2844.65 595.74 2840.48 595.74 2838.39 599.36 2840.48 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M2840.52,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "2826.27 610.91 2829.22 607.96 2828.14 603.93 2824.11 602.85 2821.16 605.8 2822.24 609.83 2826.27 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M2823.74,608.32c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "2821.83 626.56 2821.83 622.39 2818.22 620.31 2814.6 622.39 2814.6 626.56 2818.22 628.65 2821.83 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M2818.22,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "2829.77 640.77 2826.82 637.82 2822.79 638.9 2821.71 642.93 2824.66 645.88 2828.69 644.8 2829.77 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M2827.18,643.3c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89.8-.8,2.09-.8,2.89,0s.8,2.09,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 2842.95,
    cy: 624.09,
    r: 18.8,
    transform: "translate(1582.38 3247.6) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-49",
    cx: 2842.95,
    cy: 624.09,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2948.35,580.58h-10.29l-16.86-36.19h43.48l-4.28,25.96c-.97,5.9-6.07,10.22-12.05,10.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2697.84,544.39l5.86,62.92c.69,7.38,6.88,13.02,14.29,13.02h2.92l37.08-75.94h-60.14ZM2722.61,598.82c-5.11,0-9.26-4.15-9.26-9.26s4.15-9.26,9.26-9.26,9.26,4.15,9.26,9.26-4.15,9.26-9.26,9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M2958.4,624.09h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M2952.16,624.09h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 2482.35,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 2496.24,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2482.35,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 2496.24,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 2710.93,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 2724.82,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 2710.93,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 2724.82,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 2939.51,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 2953.39,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M2526.71,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M2691.45,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M2767.57,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M2932.3,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M520.19,508.64c-.43,0-.87,0-1.31-.02-1.1-.03-1.97-.95-1.94-2.06.03-1.1,1.01-1.99,2.06-1.94,15.42.5,24.15-7.9,32.6-15.98,7.03-6.72,13.67-13.07,23.48-13.89,7.96-.72,12.67,4.09,16.44,7.91,2.96,3,4.73,4.65,6.8,4.12,3.87-1.01,3.65-7.02,2.95-14.77-.59-6.54-1.14-12.71,3.64-13.66,4.73-.94,6.97,4.44,9.33,10.15,2.16,5.21,4.6,11.11,8.51,11.11.04,0,.09,0,.13,0,.85-.03,1.23-.33,1.46-.59,1.65-1.86,1.15-7.63.75-12.27-.6-6.93-1.16-13.48,3.8-14.36,5.12-.94,7.49,6.12,9.99,13.54,1.74,5.17,4.13,12.25,6.63,12.33.24.04.32-.04.43-.15,1.49-1.47,1.41-7.93,1.35-12.65-.1-8.01-.19-14.93,4.74-15.12,5.17-.14,7.45,8.16,9.86,17.03.71,2.59,1.61,5.9,2.37,7.75.78-2.16,1.66-6.24,2.3-9.17,2.04-9.46,3.81-17.64,8.4-17.64h.04c4.36.04,4.72,6.43,5.18,14.52.28,5.04.82,14.42,3.1,14.49.01,0,.02,0,.03,0,2.22,0,4.16-8.04,5.33-12.85,1.54-6.35,2.87-11.84,5.83-13.61.99-.59,2.1-.75,3.22-.46,4.93,1.28,5.46,8.22,6.02,15.55.34,4.47.81,10.59,2.64,11.62,1.19.65,3.08-1.53,5.63-4.71,3.26-4.09,7.33-9.17,12.88-7.52,2.53.75,4.4,2.52,6.57,4.56,5.81,5.48,15.54,14.65,51.82,16.05,1.1.04,1.96.97,1.92,2.07-.04,1.1-.99,2.03-2.07,1.92-37.78-1.45-48.19-11.27-54.41-17.14-1.94-1.83-3.34-3.15-4.96-3.64-2.77-.82-5.31,2.05-8.61,6.18-3.03,3.79-6.46,8.09-10.71,5.7-3.7-2.08-4.17-8.26-4.67-14.8-.37-4.82-.88-11.43-3.04-11.99-1.69.93-3.12,6.84-4.16,11.15-1.98,8.18-3.85,15.9-9.19,15.9-.06,0-.12,0-.18,0-5.94-.19-6.46-9.38-6.97-18.27-.21-3.71-.52-9.19-1.39-10.63-1.51,1.32-3.33,9.76-4.33,14.37-1.87,8.64-2.9,13.42-6.12,13.42h-.06c-3.05-.05-4.19-4.23-6.25-11.8-1.05-3.86-3.83-14.08-5.83-14.08h-.02c-1.03.85-.95,7.26-.9,11.08.09,6.63.17,12.89-2.55,15.55-.91.89-2.08,1.31-3.36,1.3-5.27-.17-7.71-7.39-10.29-15.05-1.32-3.91-3.73-11.08-5.51-10.89-1.35.24-.78,6.89-.51,10.08.51,5.96,1.04,12.13-1.74,15.27-1.07,1.21-2.57,1.88-4.32,1.94-6.77.14-9.92-7.43-12.47-13.58-1.41-3.4-3.35-8.14-4.85-7.76-1.26.25-.73,6.2-.44,9.39.68,7.59,1.53,17.04-5.92,18.99-4.41,1.14-7.59-2.07-10.66-5.18-3.52-3.56-7.12-7.2-13.26-6.74-8.41.71-14.55,6.58-21.05,12.8-8.4,8.03-17.89,17.11-34.16,17.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M453.82,389.25v91.35h70.94v-91.35h-70.94ZM503.59,446.54c0,5.57-6.4,10.09-14.3,10.09s-14.3-4.52-14.3-10.09v-33.67c0-5.57,6.4-10.09,14.3-10.09s14.3,4.52,14.3,10.09v33.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M453.82,378.02v114.26h70.94v-114.26h-70.94ZM503.59,449.67c0,6.97-6.4,12.61-14.3,12.61s-14.3-5.65-14.3-12.61v-42.11c0-6.97,6.4-12.62,14.3-12.62s14.3,5.65,14.3,12.62v42.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M453.82,372.54v129.54h70.94v-129.54h-70.94ZM503.59,453.78c0,7.9-6.4,14.3-14.3,14.3s-14.3-6.4-14.3-14.3v-47.74c0-7.9,6.4-14.3,14.3-14.3s14.3,6.4,14.3,14.3v47.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M470.14,492.68c0,3.21-2.6,5.82-5.82,5.82s-5.82-2.6-5.82-5.82,2.6-5.82,5.82-5.82,5.82,2.6,5.82,5.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M468.44,492.68c0,2.27-1.84,4.11-4.11,4.11s-4.11-1.84-4.11-4.11,1.84-4.11,4.11-4.11,4.11,1.84,4.11,4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M520.07,492.68c0,3.21-2.6,5.82-5.82,5.82s-5.82-2.6-5.82-5.82,2.6-5.82,5.82-5.82,5.82,2.6,5.82,5.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-189",
    cx: 514.26,
    cy: 492.68,
    r: 4.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M3055.65,502.25h36.11v47.75h-36.11c-5.94,0-10.76-4.82-10.76-10.76v-26.23c0-5.94,4.82-10.76,10.76-10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M3090.83,527.94h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.72-2.56-5.72-5.72v-7.36c0-3.16,2.56-5.72,5.72-5.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 3091.47,
    y: 529.34,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3091.58,
    y: 529.66,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 3089.76,
    y: 529.34,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3089.87,
    y: 529.66,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 3088.05,
    y: 529.34,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3088.16,
    y: 529.66,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3090.83,505.52h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.72-2.56-5.72-5.71v-7.36c0-3.16,2.56-5.72,5.72-5.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 3091.47,
    y: 506.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 3091.58,
    y: 507.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 3089.76,
    y: 506.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 3089.87,
    y: 507.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 3088.05,
    y: 506.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 3088.16,
    y: 507.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 3063.71,
    y: 478.98,
    width: 15.99,
    height: 71.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 3071.7,
    y: 457.44,
    width: 15.99,
    height: 171.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 3071.7,
    y: 574.21,
    width: 15.99,
    height: 55.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M358.13,246.19c-3-8.99-13.79-25.78-34.17-28.78-20.38-3-206.85,2.4-218.24,7.79-11.39,5.4-74.34,176.26-74.34,206.04,0,38.17-2.8,68.16,2.8,89.94h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h116.29v-20.18c0-3.87,3.14-7,7-7,2.24,0,4.05-1.81,4.05-4.05v-86.69c0-27.98-8.79-120.51-11.79-129.5ZM242.02,363.06c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69ZM338.35,362.2c0,6.13-4.97,11.09-11.09,11.09h-41.37c-6.13,0-11.09-4.97-11.09-11.09v-91.13c0-6.13,4.97-11.09,11.09-11.09h41.37c6.13,0,11.09,4.97,11.09,11.09v91.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M337.15,434.76c-124.03,0-234.59,18.08-306.44,46.31.03,2.13.08,4.2.15,6.24,71.85-28.19,182.35-46.25,306.3-46.25,11.04,0,21.96.15,32.77.43v-6.3c-10.81-.28-21.73-.43-32.77-.43Z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 341,
    height: 81,
    transform: "translate(29.79 440.22)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "168.54 521.19 36.87 521.19 36.87 594.03 69.75 594.03 69.75 633.1 77.54 633.1 77.54 594.03 119.51 594.03 119.51 633.1 127.3 633.1 127.3 594.03 138.96 594.03 168.54 521.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "136.02 568.75 69.75 568.75 69.75 528.58 154.28 528.58 136.02 568.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 67.8,
    y: 626.53,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M123.79,208.5h219.58v24.37H99.63v-.21c0-13.34,10.83-24.16,24.16-24.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M360.3,206.55V50.36s-216.57,125.18-239.8,148.15c-23.23,22.97-20.79,32.45-20.79,32.45l260.59-24.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M360.3,216.88v-72.11s-216.57,51.79-239.8,66.84c-23.23,15.04-20.79,21.26-20.79,21.26l260.59-15.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M128.48,564.15h-46.45c-4.11,0-7.45-3.34-7.45-7.45v-28.12h74.86l-14.19,31.21c-1.21,2.66-3.86,4.37-6.78,4.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 67.8,
    y: 623.24,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M65.35,633.1H31.17c-15.56,0-28.18-39.53-28.18-54.76v-38.48c0-8.95,7.49-16.28,16.64-16.28h45.72v109.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 765.14,
    width: 2328.31,
    height: 484.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 772.04,
    y: 6,
    width: 2314.51,
    height: 472.98
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "776.37 8.79 3086.55 8.79 3086.55 6 772.04 6 772.04 478.98 776.37 478.98 776.37 8.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M358.13,246.19c-1.84-5.52-6.63-13.96-14.75-20.36v-7.91l16.92-1.04V50.36s-216.57,125.18-239.8,148.15c-23.23,22.97-20.79,32.45-20.79,32.45h.01c-.02.26-.03.53-.04.8-.04.3-.05.53-.04.71,0,.07,0,.13,0,.2v.21h.45c-19.11,34.37-68.71,171.94-68.71,198.37,0,38.17-2.8,68.16,2.8,89.94h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h116.29v-20.18c0-3.87,3.14-7,7-7,2.23,0,4.05-1.81,4.05-4.05v-86.69c0-27.98-8.79-120.51-11.79-129.5ZM242.02,363.06c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.58c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69ZM338.35,362.2c0,6.13-4.97,11.09-11.09,11.09h-41.37c-6.13,0-11.09-4.97-11.09-11.09v-91.13c0-6.13,4.97-11.09,11.09-11.09h41.37c6.13,0,11.09,4.97,11.09,11.09v91.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 210.85,
    y: 419.28,
    width: 39.07,
    height: 16.37,
    rx: 8.19,
    ry: 8.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 215.55,
    y: 423.89,
    width: 28.17,
    height: 7.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M208.82,423.89h7.62v7.14h-7.62c-1.97,0-3.57-1.6-3.57-3.57h0c0-1.97,1.6-3.57,3.57-3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M246.39,423.89h7.62v7.14h-7.62c-1.97,0-3.57-1.6-3.57-3.57h0c0-1.97,1.6-3.57,3.57-3.57Z",
    transform: "translate(496.84 854.93) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 216.97,
    y: 424.89,
    width: 25.34,
    height: 5.14,
    rx: 1.11,
    ry: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 76.19,
    y: 502.95,
    width: 20.71,
    height: 12.88,
    rx: 1.64,
    ry: 1.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 77.32,
    y: 503.89,
    width: 18.45,
    height: 11,
    rx: 2.33,
    ry: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 92.89,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 93.08,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 89.92,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.11,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 86.94,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.14,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 83.97,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.16,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 81,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 81.19,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 78.03,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 78.22,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M18.53,393.26c-.4.12-.83.17-1.27.14-1.82-.12-3.08-1.54-2.83-3.19,2.09-13.66-6.85-24.06-6.94-24.16-1.09-1.25-.8-3.13.67-4.21,1.46-1.08,3.54-.94,4.64.31.44.49,10.68,12.3,8.21,28.48-.19,1.25-1.2,2.26-2.47,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M9.49,363.1c-.43-.49-1.03-.76-1.67-.9-1.12,1.1-1.32,2.71-.33,3.84.09.1,3.87,7.76,6.94,24.16.28,1.48.82,2.75,2.37,3.07.47-.46.8-1.05.9-1.7,2.47-16.18-7.77-27.99-8.21-28.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M130,253.18h-4.65c-.96,0-1.78.58-2.17,1.4H25.75c-13.21,0-23.95,10.75-23.95,23.95v96.79c0,9.82,5.89,18.54,15,22.21l65.88,26.56c.03,1.3,1.08,2.35,2.39,2.35h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4h-4.65c-.44,0-.82.15-1.18.35l-66.2-26.69c-5.23-2.11-9.27-6.08-11.51-10.97l7.92-3.19c.63-.25.94-.97.68-1.61-.25-.63-.97-.94-1.61-.68l-7.89,3.18c-.69-2.13-1.09-4.39-1.09-6.72v-62.87h12.78c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2H4.19v-31.52c0-11.89,9.67-21.55,21.55-21.55h97.71c.44.59,1.1,1,1.9,1h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-177",
    cx: 17.58,
    cy: 310.34,
    rx: 6.1,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M18.35,267.81h.98v85.07h-.98c-4.61,0-8.34-3.74-8.34-8.34v-68.38c0-4.61,3.74-8.34,8.34-8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M10,276.08h.1c1.8,0,3.25,1.46,3.25,3.25v62.02c0,1.8-1.46,3.25-3.25,3.25h-.1v-68.53h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2933.47,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.12,
    ry: 2.12,
    transform: "translate(5898.26 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 2934.85,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(5883.57 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 2935.38,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5872.39 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 2935.78,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5872.65 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 2937.62,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5876.87 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 2938.02,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5877.12 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 2939.85,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5881.34 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 2940.25,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5881.59 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 2942.09,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5885.81 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 2942.49,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5886.07 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 2944.33,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5890.28 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 2944.73,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5890.54 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 2946.56,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5894.75 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 2946.96,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5895.01 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 2949.54,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(5912.96 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 2950.07,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5901.78 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2950.47,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5902.03 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M2952.77,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(5906.25 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2952.71,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5906.5 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 2954.54,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5910.72 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2954.94,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5910.97 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 2956.78,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5915.19 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2957.18,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5915.45 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M2959.48,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(5919.66 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2959.42,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5919.92 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 2961.25,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5924.13 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2961.65,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5924.39 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2219.37,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.12,
    ry: 2.12,
    transform: "translate(4470.07 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 2220.75,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(4455.38 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 2221.28,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4444.2 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 2221.68,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4444.45 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 2223.52,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4448.67 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 2223.92,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4448.92 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 2225.76,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4453.14 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 2226.15,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4453.4 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 2227.99,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4457.61 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 2228.39,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4457.87 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M2230.69,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(4462.08 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 2230.63,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4462.34 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 2232.46,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4466.56 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 2232.86,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4466.81 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 2235.44,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(4484.76 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 2235.97,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4473.58 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2236.37,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4473.83 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 2238.21,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4478.05 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2238.61,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4478.31 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 2240.45,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4482.52 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2240.85,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4482.78 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 2242.68,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4486.99 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2243.08,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4487.25 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 2244.92,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4491.47 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2245.32,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4491.72 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 2247.15,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4495.94 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2247.55,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4496.19 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 1505.27,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.12,
    ry: 2.12,
    transform: "translate(3041.87 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1506.65,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(3027.18 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 1507.18,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3016 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 1507.58,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3016.25 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 1509.42,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3020.47 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 1509.82,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3020.73 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 1511.66,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3024.94 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 1512.06,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3025.2 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 1513.89,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3029.41 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 1514.29,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3029.67 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 1516.13,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3033.89 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 1516.53,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3034.14 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 1518.36,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3038.36 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 1518.76,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3038.61 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 1521.34,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(3056.56 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 1521.88,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3045.38 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1522.27,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3045.64 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 1524.11,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3049.85 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1524.51,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3050.11 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 1526.35,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3054.32 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1526.75,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3054.58 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 1528.58,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3058.8 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1528.98,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3059.05 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 1530.82,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3063.27 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.22,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3063.52 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 1533.05,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3067.74 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1533.45,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3068 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 791.17,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.12,
    ry: 2.12,
    transform: "translate(1613.67 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 792.55,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(1598.98 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 793.09,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1587.8 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 793.49,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1588.06 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M795.78,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(1592.27 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 795.72,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1592.53 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 797.56,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1596.75 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 797.96,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1597 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 799.79,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1601.22 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 800.19,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1601.47 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 802.03,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1605.69 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 802.43,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1605.94 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 804.27,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1610.16 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 804.66,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1610.42 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 807.24,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(1628.36 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 807.78,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1617.18 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 808.18,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1617.44 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 810.01,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1621.66 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 810.41,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1621.91 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 812.25,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1626.13 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 812.65,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1626.38 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 814.48,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1630.6 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 814.88,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1630.85 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 816.72,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1635.07 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 817.12,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1635.33 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 818.96,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1639.54 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 819.36,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1639.8 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M383.6,535.42c0-25.52-20.69-46.21-46.21-46.21h-104.53c-30.03,0-57.31,17.48-69.85,44.76l-27.85,60.56h7.1c8.07,0,15.4-4.7,18.77-12.03l18.77-40.81c9.53-20.72,30.25-34,53.05-34h104.54c15.31,0,27.73,12.41,27.73,27.73v45.06c0,7.76,6.29,14.06,14.06,14.06h4.43v-59.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M359.1,249.49H119.55c-8.54,0-16.2,5.07-19.52,12.93-10.67,25.25-35.48,90.47-35.48,150.45v108.32h2.4v-108.32c0-59.55,24.68-124.4,35.29-149.52,2.94-6.96,9.73-11.46,17.31-11.46h135.21c2.15.72,3.72,2.73,3.72,5.12v217.13c0,9.58-7.79,17.37-17.37,17.37h-5.71v1.8h5.71c10.57,0,19.17-8.6,19.17-19.17v-217.13c0-2-.82-3.81-2.14-5.12h100.96c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M388.31,533.18c0-26.49-21.47-47.96-47.96-47.96h-108.5c-31.17,0-59.48,18.14-72.5,46.46l-28.91,62.86h7.37c8.38,0,15.98-4.88,19.48-12.49l19.48-42.36c9.89-21.51,31.39-35.29,55.07-35.29h108.5c15.89,0,28.78,12.88,28.78,28.78v46.76c0,8.06,6.53,14.59,14.59,14.59h4.6v-61.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M30.75,473.62h0c-.26,18.74.1,34.62,3.43,47.56h8.89v-35.24c0-6.8-5.52-12.32-12.32-12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M44.27,485.94c0-7.45-6.06-13.52-13.52-13.52-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2c6.13,0,11.12,4.99,11.12,11.12v35.24h2.4v-35.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M41.57,434.27c0-21.13,28.84-110.02,51.01-167.03,1.36-3.5-1.23-7.26-4.99-7.26h-.22c-22.55,52.9-55.99,149.56-55.99,171.26,0,2.71-.02,5.37-.04,8.01h5.3c2.72,0,4.94-2.2,4.94-4.93v-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M94.38,418.55c-4.24,0-8.36-1.43-11.78-4.18-4.74-3.81-7.33-9.49-7.08-15.57,1.61-40.29,11.3-79.94,31.43-128.55,3.15-7.61,9.39-11.47,18.56-11.47h107.92c4.53,0,9.79,5.06,9.79,11.59v92.69c0,9.98-6.74,18.73-16.39,21.27l-127.56,33.58c-1.62.43-3.26.64-4.88.64ZM125.5,261.18c-8.21,0-13.56,3.27-16.34,9.99-20.01,48.34-29.65,87.73-31.25,127.73-.21,5.32,2.04,10.28,6.19,13.61,4.13,3.31,9.43,4.44,14.55,3.09l127.56-33.58c8.6-2.26,14.61-10.06,14.61-18.95v-92.69c0-4.95-4.07-9.19-7.39-9.19h-107.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M327.26,374.5h-41.37c-6.78,0-12.29-5.51-12.29-12.29v-91.13c0-6.78,5.51-12.29,12.29-12.29h41.37c6.78,0,12.29,5.51,12.29,12.29v91.13c0,6.78-5.51,12.29-12.29,12.29ZM285.89,261.18c-5.45,0-9.89,4.44-9.89,9.89v91.13c0,5.45,4.44,9.89,9.89,9.89h41.37c5.45,0,9.89-4.44,9.89-9.89v-91.13c0-5.45-4.44-9.89-9.89-9.89h-41.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M36.63,440.45h-5.3c-.66,0-1.2-.54-1.2-1.2s.54-1.2,1.2-1.2h5.3c2.06,0,3.74-1.67,3.74-3.73,0-22.09,30.26-113.96,51.09-167.51.5-1.29.34-2.68-.44-3.82-.79-1.15-2.04-1.81-3.43-1.81-.66,0-1.31-.54-1.31-1.2s.42-1.2,1.09-1.2c2.39,0,4.41,1.07,5.63,2.85,1.22,1.78,1.48,4.04.69,6.05-23.55,60.54-50.92,146.5-50.92,166.59,0,3.43-2.75,6.18-6.14,6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1622.81,666.29h0c-1.99,0-3.61-1.61-3.61-3.61v-53.66c0-1.99,1.61-3.61,3.61-3.61h0c1.99,0,3.61,1.61,3.61,3.61v53.66c0,1.99-1.62,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 1913.06,
    y: 605.41,
    width: 7.21,
    height: 60.88,
    rx: 3.61,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M2210.52,666.29h0c-1.99,0-3.61-1.61-3.61-3.61v-53.66c0-1.99,1.62-3.61,3.61-3.61h0c1.99,0,3.61,1.61,3.61,3.61v53.66c0,1.99-1.61,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M1769.74,662.69h0c-1.99,0-3.61-1.61-3.61-3.61v-160.5c0-1.99,1.61-3.61,3.61-3.61h0c1.99,0,3.61,1.62,3.61,3.61v160.5c0,1.99-1.61,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M2063.59,662.69h0c-1.99,0-3.61-1.61-3.61-3.61v-160.5c0-1.99,1.61-3.61,3.61-3.61h0c1.99,0,3.61,1.62,3.61,3.61v160.5c0,1.99-1.61,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1475.87,612.6h881.59c1.99,0,3.6-1.61,3.6-3.6s-1.61-3.6-3.6-3.6h-881.59c-1.99,0-3.6,1.61-3.6,3.6s1.61,3.6,3.6,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1475.87,558.92h881.59c1.99,0,3.6-1.61,3.6-3.6s-1.61-3.6-3.6-3.6h-881.59c-1.99,0-3.6,1.61-3.6,3.6s1.61,3.6,3.6,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1499.58,666.29h834.16c15.06,0,27.31-12.25,27.31-27.31v-140.41c0-1.99-1.61-3.6-3.6-3.6s-3.6,1.61-3.6,3.6v140.41c0,11.09-9.02,20.11-20.11,20.11h-834.16c-11.09,0-20.11-9.02-20.11-20.11v-140.41c0-1.99-1.61-3.6-3.6-3.6s-3.6,1.61-3.6,3.6v140.41c0,15.06,12.25,27.31,27.31,27.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M1586.3,612.6h32.91v46.49h-32.91v7.2h73.42v-7.2h-33.29v-46.49h33.29v-7.19h-73.42v7.19ZM1472.27,638.98c0,15.06,12.25,27.31,27.31,27.31h13.3v-7.2h-13.3c-11.09,0-20.11-9.02-20.11-20.11v-26.38h33.41v-7.19h-40.61v33.57ZM2320.45,605.41v7.19h33.41v26.38c0,11.09-9.02,20.11-20.11,20.11h-13.3v7.2h13.3c15.06,0,27.31-12.25,27.31-27.31v-33.57h-40.61ZM1879.96,612.6h33.1v46.49h-33.1v7.2h73.42v-7.2h-33.1v-46.49h33.1v-7.19h-73.42v7.19ZM1733.13,612.6h33v46.48s0,0,0,0h-33v7.2h73.42v-7.2h-33.2s0,0,0,0v-46.48h33.2v-7.19h-73.42v7.19ZM2173.62,612.6h33.29v46.49h-33.29v7.2h73.42v-7.2h-32.91v-46.49h32.91v-7.19h-73.42v7.19ZM2026.79,612.6h33.2v46.48s0,0,0,0h-33.2v7.2h73.42v-7.2h-33s0,0,0,0v-46.48h33v-7.19h-73.42v7.19Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4AxTandemSingle);
export default __webpack_public_path__ + "static/media/4-Ax_Tandem-Single.a8a70aeefba2bba6f41b76ab8c1e96ad.svg";
export { ForwardRef as ReactComponent };